// Accounts allowed to see the demo-only pages (Product / Statement / Template).
// Matching is case-insensitive and trimmed. Leaving the list empty hides the demo
// pages from everyone (safe default). Add the demo account's email here once it is
// registered — it is the ONLY control that reveals these pages.
export const DEMO_EMAILS = [
  "zwang55@kent.edu", // demo account (role: user) — shows the Product / Statement / Template demo pages
  "pangyiming020301@gmail.com",
];

export const isDemoUser = (email) => {
  if (!email) return false;
  const e = String(email).trim().toLowerCase();
  return DEMO_EMAILS.map((x) => String(x).trim().toLowerCase()).includes(e);
};
